import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import { mergeSx } from '@/lib/mergeSx';
export function BannerTitle(t0) {
  const $ = _c(12);
  let children;
  let props;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      sx,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = sx;
    $[4] = t1;
  } else {
    children = $[1];
    props = $[2];
    sx = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "h1" : t1;
  let t2;
  if ($[5] !== sx) {
    t2 = mergeSx({
      color: "white",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
      fontWeight: "bold",
      fontSize: {
        xs: "1.5rem",
        md: "3rem"
      },
      marginBottom: "1rem"
    }, sx);
    $[5] = sx;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== t2 || $[10] !== variant) {
    t3 = <Typography variant={variant} sx={t2} {...props}>{children}</Typography>;
    $[7] = children;
    $[8] = props;
    $[9] = t2;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}